import { render, staticRenderFns } from "./OrderStats.vue?vue&type=template&id=497392d6&"
import script from "./OrderStats.vue?vue&type=script&lang=js&"
export * from "./OrderStats.vue?vue&type=script&lang=js&"
import style0 from "./OrderStats.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports